import { render, staticRenderFns } from "./leftMain.vue?vue&type=template&id=2b751e92&scoped=true&"
import script from "./leftMain.vue?vue&type=script&lang=js&"
export * from "./leftMain.vue?vue&type=script&lang=js&"
import style0 from "./leftMain.vue?vue&type=style&index=0&id=2b751e92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b751e92",
  null
  
)

export default component.exports